@let feedbackDraft = insightPopupService.feedbackDraft$ | async;
@let feedbackData = feedbackData$| async;

<div class="mm-feedback-insight" *ngIf="feedbackData !== undefined && feedbackData !== null">
    <mm-feedback [data]="feedbackData"
                 [draftNewFeedbackData]="feedbackDraft ?? undefined"
                 [allowReset]="true"
                 [checkIfFeedbackAllow]="false"
    ></mm-feedback>
</div>

